(function ($, window) {
    /**
     * Add items to cart
     */
    var addToCart = function (element) {
        var quantity = '';
        var selectedOption = false;
        var isProductList = $('body').find('.product-list');
        var variationId = '0';
        var variationnodepath = '';

        if (isProductList.length > 0) {
            quantity = element.parents('.product-buttons').find('.quantity').val();
            selectedOption = element.parents('.product-buttons').find('select option:selected');
        } else {
            quantity = $('body').find('#quantity').val();
            selectedOption = $('body').find('.product-attributes').find('select option:selected');
        }

        if (selectedOption !== false) {
            if(selectedOption.data('variationnodepath')) {
                variationnodepath = selectedOption.data('variationnodepath');
            } else {
                variationnodepath = element.data('productnodepath');
            }
            if(selectedOption.data('variationid')) {
                variationId = selectedOption.data('variationid');
            }
        }

        var language = element.data('language');

        jQuery.ajax({
            url: _AVENCY_BASE_actions.cart.addCartItem,
            type: 'POST',
            data: {
                cartItemIdentifier: element.data('sku') + '/' + variationId,
                node: variationnodepath,
                quantity: quantity,
                language: language,
                __csrfToken: window._AVENCY_SHOP_csrfToken
            },
            dataType: 'json',
            success: function (data) {
                showAndReloadCartSmall();

                iziToast.show({
                    class: 'iziToast-success',
                    animateInside: false,
                    progressBar: false,
                    timeout: 3200,
                    transitionIn: 'fadeInLeft',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut',
                    icon: 'ai ai-checkmark-circle2',
                    message: _AVENCY_BASE_translations.cart.addToCart.success,
                    position: 'topRight'
                });

                if (data.redirect) {
                    window.location.href = data.redirect;
                }
            },
            error: function (data) {
                var message = _AVENCY_BASE_translations.cart.addToCart.error;
                if (data.responseJSON) {
                    message = data.responseJSON.errorMessage;
                }

                iziToast.show({
                    class: 'iziToast-danger',
                    animateInside: false,
                    progressBar: false,
                    timeout: 9000,
                    transitionIn: 'fadeInLeft',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut',
                    icon: 'ai ai-circle-minus',
                    message: message,
                    position: 'topRight'
                });
            }
        });
    };

    $('body').on('click', '.addToCart', function () {
        addToCart($(this));
    });

    $('body').on('keypress', '.product-buttons .quantity', function (e) {
        if (e.keyCode == 13) {
            addToCart($(this).parents('.product-buttons').find('.addToCart'));
        }
    });

    $('body').on('keypress', '#quantity', function (e) {
        if (e.keyCode == 13) {
            addToCart($('body').find('.addToCart'));
        }
    });

    /**
     * Remove item in cart
     */
    $('body').on('click', '.dropdown-product-remove', function () {
        var cartitemidentifier = $(this).parent('.dropdown-product-item').data('cartitemidentifier');
        var language = $(this).data('language');

        jQuery.ajax({
            url: _AVENCY_BASE_actions.cart.removeCartItem,
            type: 'POST',
            data: {
                cartItemIdentifier: cartitemidentifier,
                language: language,
                __csrfToken: window._AVENCY_SHOP_csrfToken
            },
            dataType: 'json',
            success: function () {
                showAndReloadCartSmall();
            }
        });
    });

    window.showAndReloadCartSmall = function() {
        jQuery.ajax({
            url: $('#small-cart').data('small-cart-url'),
            type: 'POST',
            data: {},
            success: function (data) {
                $('#small-cart').html(data);
            }
        });
    };

    showAndReloadCartSmall();
    window.addToCart = addToCart;
})(jQuery, window);
